// Quoting alone does not stop Excel/Sheets from evaluating an exported formula.
export function csvCell(value: unknown): string {
  const text = String(value ?? '');
  const safe = /^[\s]*[=+@-]|^[\t\r\n]/.test(text) ? "'" + text : text;
  return `"${safe.replace(/"/g, '""')}"`;
}
